/* eslint-disable complexity */

import algoliasearch from 'algoliasearch'
import instantsearch from 'instantsearch.js'
import searchRouting from './search-routing'
import { configure } from 'instantsearch.js/es/widgets'
import { getUrlParameter, toggleDisplaySections } from '../../../helper-functions'
import accordionSimple from '../../molecules/accordion/accordion-simple'
import statsWidgets from '../../molecules/algolia-widgets/stats'
import searchBoxWidgets from '../../molecules/algolia-widgets/search-box'
import hitsWidget from '../../molecules/algolia-widgets/hits'
import paginationWidgets from '../../molecules/algolia-widgets/pagination'
import refinementListWidgets from '../../molecules/algolia-widgets/refinement-list'
import menuWidgets from '../../molecules/algolia-widgets/menu'
import hierarchicalMenuWidgets from '../../molecules/algolia-widgets/hierarchical-menu'
import menuSelectWidgets from '../../molecules/algolia-widgets/menu-select'

/**
 * Instant Search v4 init and widgets.
 *
 * Docs: https://www.algolia.com/doc/api-reference/widgets/instantsearch/js/
 */
export default function instantSearch() {
  if ( !window.algolia ) {
    return
  }

  Array.from( document.querySelectorAll( '.js-instant-search-init' ) ).forEach(
    container => main( container )
  )

  /**
   * Initialize instant search and its widgets.
   *
   * @param {Element} mainContainer The search main container.
   */
  function main( mainContainer ) {

    /*****************************************************************************************************************
     * Helper functions.
     *****************************************************************************************************************/
    /**
     * Toggles the visibility of some search sections.
     *
     * @param {bool} toggle To toggle or not.
     * @return {null} Void.
     */
    const hiddeOnNoResults = toggle => toggleDisplaySections(
      mainContainer,
      '.js-instant-search-hide-on-no-results',
      toggle
    )

    /*****************************************************************************************************************
     Instantiate instantsearch.js
     ******************************************************************************************************************/
    const searchClient = algoliasearch( window.algolia.application_id, window.algolia.search_api_key )
    const indexName = mainContainer.dataset.algoliaIndex

    const search = instantsearch({
      indexName: indexName,
      searchClient,
      routing: mainContainer.dataset.urlSync
        && 'true' === mainContainer.dataset.urlSync
        && searchRouting( indexName )
        || false,
      searchFunction( helper ) {
        hiddeOnNoResults( helper.state.query === '' )
        helper.search()
      },
      onStateChange({ uiState, setUiState }) {
        hiddeOnNoResults( uiState.query && uiState.query.toString() === '' )
        setUiState( uiState )
      }
    })

    /**
     * Add styles to the accordions on widget render.
     */
    search.on( 'render', () => {
      accordionSimple()
    })

    /*****************************************************************************************************************
     * Initial filtering
     ******************************************************************************************************************/
    // Filter language.
    const filterLanguage = mainContainer.dataset.filterLanguage
      && 'true' === mainContainer.dataset.filterLanguage
      && `taxonomies.language:${ window.language.current_language }` || ''

    // Filter by State if URL query param exists.
    const stateAbbrQueryParam = getUrlParameter( window.location.href, 'state-abbr' )
    const filterState = stateAbbrQueryParam && ` AND state_abbreviation:${ stateAbbrQueryParam }` || ''

    // Filter by File Type.
    const filterFileType = mainContainer.dataset.filterFileType
      && ` AND type:${ encodeURI( mainContainer.dataset.filterFileType ) }` || ''

    /*****************************************************************************************************************
     * Configure widget (API settings).
     *****************************************************************************************************************/
    const configureWidget =
      configure({
        hitsPerPage: mainContainer.dataset.hitsPerPage || 10,
        filters: `${ filterLanguage }${ filterState }${ filterFileType }`
      })

    /*****************************************************************************************************************
     * Load Widgets and start Instant Search.
     *****************************************************************************************************************/
    search.addWidgets([configureWidget])
    search.addWidgets( menuSelectWidgets( mainContainer ) )
    search.addWidgets( hierarchicalMenuWidgets( mainContainer ) )
    search.addWidgets( menuWidgets( mainContainer ) )
    search.addWidgets( refinementListWidgets( mainContainer ) )
    search.addWidgets( paginationWidgets( mainContainer ) )
    search.addWidgets( hitsWidget( mainContainer ) )
    search.addWidgets( searchBoxWidgets( mainContainer ) )
    search.addWidgets( statsWidgets( mainContainer ) )

    search.start()
  }
}
